__turbopack_context__.v({
  "text-link-buttons": "text-link-buttons-component-module-scss-module__dObpUq__text-link-buttons",
  "text-link-buttons__button": "text-link-buttons-component-module-scss-module__dObpUq__text-link-buttons__button",
  "text-link-buttons__buttons": "text-link-buttons-component-module-scss-module__dObpUq__text-link-buttons__buttons",
  "text-link-buttons__buttons-wrapper": "text-link-buttons-component-module-scss-module__dObpUq__text-link-buttons__buttons-wrapper",
});
